export const aciWheelchairAccessible = {
    iconName: 'wheelchair-accessible',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: {
            attr: {
                d: 'M9.479 3.892a2.373 2.373 0 104.745 0 2.373 2.373 0 00-4.745 0v0zM17.417 20.77l-1.66-3.32h-3.906a1.356 1.356 0 01-1.356-1.355v-6.78a1.356 1.356 0 112.712 0v5.424h3.39a1.356 1.356 0 011.212.75l2.034 4.067a1.357 1.357 0 01-2.426 1.213v0zM13.207 20.793a5.424 5.424 0 01-5.423-9.396',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
